import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getFirestore, doc, getDoc } from 'firebase/firestore'; 
import { ReactComponent as EventosIcon } from '../assets/icons/EventosIcon.svg';
import { ReactComponent as DegustacionIcon } from '../assets/icons/MiembrosIcon.svg'; // Asume que tienes este
import { ReactComponent as DemoIcon } from '../assets/icons/MenuIcon.svg';
import LoadingSpinner from '../assets/LoadingSpinner';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../contexts/ToastContext';
const formatearFechaEvento = (fechaString) => {
const fecha = new Date(fechaString);
const opcionesFecha = {
weekday: 'long',
day: 'numeric',
month: 'long',
timeZone: 'UTC'
};
const diaMes = new Intl.DateTimeFormat('es-ES', opcionesFecha).format(fecha).toUpperCase();
return diaMes;
};
const compararReservasPorFecha = (a, b) => {
const fechaA = a.fechas && a.fechas.length > 0 ? new Date(a.fechas[0]) : null;
const fechaB = b.fechas && b.fechas.length > 0 ? new Date(b.fechas[0]) : null;
if (fechaA && fechaB) {
return fechaA.getTime() - fechaB.getTime();
}
if (!fechaA && fechaB) return 1;
if (fechaA && !fechaB) return -1;
return 0;
};
function ConfirmModal({ title, message, onConfirm, onCancel, isProcessing }) {
return (
<div className="modal-backdrop">
<div className="modal-content" style={{width:'500px'}}>
<h2 className="modal-title" style={{fontSize:'14px', margin:'0 auto 10px', width:'70%'}}>{title}</h2>
<p className="modal-message" style={{fontSize:'16px'}}>{message}</p>
<div className="modal-actions" style={{justifyContent:'center',margin:'0 auto', width:'90%', gap:'20px'}}>
<button
className="modal-button cancel"
style={{minWidth:'40%', fontSize:'13px'}}
onClick={onCancel}
disabled={isProcessing}
>
CANCELAR
</button>
<button
className="modal-button confirm"
style={{minWidth:'50%', fontSize:'13px'}}
onClick={onConfirm}
disabled={isProcessing}
>
{isProcessing ? 'Confirmando...' : 'Confirmar y ceder mi lugar'}
</button>
</div>
</div>
</div>
);
}
function Reservas() {
const { user, loading } = useAuth();
const navigate = useNavigate();
const { showToast } = useToast();
const [showModal, setShowModal] = useState(false);
const [reservaToCancel, setReservaToCancel] = useState(null);
const [isCancelling, setIsCancelling] = useState(false);
const [reservasDetalladas, setReservasDetalladas] = useState([]);
const [cargandoReservas, setCargandoReservas] = useState(true);
const db = getFirestore();
const openConfirmModal = (reserva) => {
setReservaToCancel(reserva);
setShowModal(true);
};
useEffect(() => {
// 1. Manejar carga/sin usuario/sin datos
if (loading || !user || !user.profileData) {
if (!loading && (!user || !user.profileData)) {
setCargandoReservas(false);
}
return;
}

const reservas = user.profileData.reservas || [];

// 💡 LÓGICA DE REDIRECCIÓN TEMPRANA: Si el array de reservas está vacío, redirigir
if (reservas.length === 0) {
setCargandoReservas(false);
// 💡 Redirigir si no hay reservas
navigate('/eventos');
return;
}
const obtenerDetallesReservas = async () => {
const reservas = user.profileData.reservas;
const detallesPromesas = reservas.map(async (reserva) => {
let coleccion, id, tipo, titulo, descripcion;
let fechas = [];
let hora = reserva.hora || '';
if (reserva.eventoId) {
coleccion = 'eventos';
id = reserva.eventoId;
tipo = 'Evento';
} else if (reserva.degustacionId) {
coleccion = 'degustaciones';
id = reserva.degustacionId;
tipo = 'Degustación';
} else if (reserva.demoId) {
coleccion = 'demostraciones';
id = reserva.demoId;
tipo = 'Demostración';
} else {
console.warn('Reserva sin ID de evento/degustación/demostración conocido:', reserva);
return null; 
}
try {
const docRef = doc(db, coleccion, id);
const docSnap = await getDoc(docRef);
if (docSnap.exists()) {
const data = docSnap.data();
titulo = data.titulo || `${tipo} sin título`;
descripcion = data.descripcion || `Detalles de la ${tipo} no disponibles.`;
fechas = data.fechas || []; 
hora = data.hora || hora;
} else {
console.warn(`Documento no encontrado en ${coleccion} con ID: ${id}`);
titulo = `${tipo} no encontrado`;
descripcion = 'El detalle del elemento no está disponible.';
}
} catch (error) {
console.error(`Error al obtener el detalle de ${coleccion}/${id}:`, error);
titulo = `Error al cargar ${tipo}`;
descripcion = 'Ocurrió un error al intentar obtener la información.';
}
if (tipo === 'Degustación' && titulo.includes('sin título')) {
titulo = 'Degustación'; 
descripcion = 'Detalles de la Degustación';
}
return {
...reserva,
tipo,
titulo,
descripcion,
fechas,
hora
};
});
const resultados = await Promise.all(detallesPromesas);
const reservasCargadas = resultados.filter(r => r !== null);
setReservasDetalladas(reservasCargadas);
setCargandoReservas(false);
};
obtenerDetallesReservas();
}, [user, loading, db]);
if (loading) {
return <LoadingSpinner/>;
}
if (!user || !user.profileData) {
return <div className="no-auth-message">Necesitas iniciar sesión para ver tus reservas.</div>;
}
if (cargandoReservas) {
return <LoadingSpinner/>;
}
if (reservasDetalladas.length === 0) {
return (
<div className="reservas-container">
<h1>Mis Reservas 📅</h1>
<p className="no-reservas-message">Aún no tienes ninguna reserva realizada.</p>
</div>
);
}

const getIconForReserva = (tipo) => {
const style = { height: '15px', overflow: 'visible', width: 'auto', margin: 'auto 0' };
switch (tipo) {
case 'Evento':
return <EventosIcon style={style} />;
case 'Degustación':
return <DegustacionIcon style={style} />;
case 'Demostración':
return <DemoIcon style={style} />;
default:
return <EventosIcon style={style} />; // Icono por defecto
}
};
const reservasOrdenadas = [...reservasDetalladas].sort(compararReservasPorFecha);
const confirmCancelation = async () => {
if (!reservaToCancel) return;
setIsCancelling(true);
const reserva = reservaToCancel;
let itemId;
if (reserva.eventoId) {
itemId = reserva.eventoId;
} else if (reserva.degustacionId) {
itemId = reserva.degustacionId;
} else if (reserva.demoId) {
itemId = reserva.demoId;
} else {
showToast('Error: La reserva no tiene un ID de item válido.', 'error');
setIsCancelling(false);
setShowModal(false);
setReservaToCancel(null);
return;
}
const payload = {
itemId: itemId,
userId: user.uid,
tipo: reserva.tipo,
invitadosNombres: reserva.invitados_nombres || []
};
try {
const idToken = await user.getIdToken();
const response = await fetch('https://backend-288175208699.europe-west1.run.app/api/cancelar-reserva', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'Authorization': `Bearer ${idToken}`,
},
body: JSON.stringify(payload),
});
const data = await response.json();
if (response.ok) {
window.location.reload(); 
} else {
showToast(`Fallo en la cancelación: ${data.message || 'Error desconocido'}`, 'error');
}
} catch (error) {
console.error('Error de red/petición:', error);
showToast('Error de conexión. Inténtalo de nuevo.', 'error');
} finally {
setIsCancelling(false);
setShowModal(false);
setReservaToCancel(null);
}
};
return (
<div className="historia-container" >
{}
{showModal && reservaToCancel && (
<ConfirmModal
title={`¿ESTÁ SEGURO QUE DESEA cancelar su reserva para ${reservaToCancel.titulo}?`}
message={`Esta acción es irreversible. Si confirma, usted perderá su reserva en este evento.`}
onConfirm={confirmCancelation}
onCancel={() => {
setShowModal(false);
setReservaToCancel(null);
}}
isProcessing={isCancelling}
/>
)}
<div className="contenido-scrollable" style={{width:'100%'}}>
<div className="titulo-principal">
<hr style={{borderColor:'#ab9374'}} className="linea-horizontal" />
<h1 style={{color:'#ab9374'}}>SUS RESERVAS</h1>
<hr style={{borderColor:'#ab9374'}} className="linea-horizontal" />
</div>
<p className="contenido-centrado">Le damos la bienvenida a su panel de gestión personal.
<br className='spacer-10px'></br>En esta sección, usted podrá consultar y administrar de forma centralizada todas las reservas activas que ha realizado con Finca Los Astros, incluyendo sus degustaciones de cortesía, demostraciones y eventos especiales. Aquí podrá verificar el estado y los detalles de cada reserva (fecha, horario y número de invitados) y gestionar modificaciones o cancelaciones, sujeto a las políticas de cada servicio.</p>
<div className="reservas-list">
{reservasOrdenadas.map((reserva, index) => (
<div key={index} className="reserva-card">
<div className="reserva-header">
<span className="reserva-fecha">
{getIconForReserva(reserva.tipo)}
{reserva.fechas && reserva.fechas.length > 0
? formatearFechaEvento(reserva.fechas[0]) + (reserva.fechas.length > 1 ? ` (+${reserva.fechas.length - 1} más)` : '')
: 'Sin fechas'} | {reserva.hora} HS
</span>
{}
<button 
className="boton-cancelar"
onClick={() => openConfirmModal(reserva)}
disabled={isCancelling}
>
Cancelar Reserva
</button>
</div>
<div className="reserva-details">
<h2 className="reserva-titulo">
{reserva.tipo === 'Evento' 
? reserva.titulo 
: reserva.tipo}
</h2>
<hr className="reserva-divider" />
<div className="reserva-invitados">
<strong className="invitados-titulo">
{reserva.tipo === 'Demostración' 
? '' 
: 'Sus invitados:'}
</strong>
<ul className="invitados-lista">
{reserva.tipo === 'Demostración' ? (
<span className="invitado-item" style={{margin:'15px 0 0 '}}>{reserva.titulo}</span>
) : (
<span className="invitados-lista-texto">
{reserva.invitados_nombres && reserva.invitados_nombres.join(', ')}
</span>
)}
</ul>
</div>
</div>
</div>
))}
</div>
</div>
</div>
);
}
export default Reservas;